module.exports = __webpack_public_path__ + "img/7F91204D-A44F-4AA3-98BE-21682046F73D.b1762bc5.svg";